module.exports = __webpack_public_path__ + "static/media/marker--selected.73199e2f.svg";